import React from "react";
import "./references.css";
import { ReferencesConfig } from "./ReferencesConfig";
import FontAwesome from "react-fontawesome";
import { FormattedMessage } from "react-intl";
import SwipeableViews from "react-swipeable-views";

class References extends React.Component {
  constructor(props) {
    super(props);
    this.state = { index: 0 };
  }

  handleChangeIndex = index => {
    if (index >= ReferencesConfig.references.length) {
      index = 0;
    }
    this.setState({
      index
    });
  };

  handleClick = index => {
    if (
      this.state.index !== index &&
      index >= 0 &&
      index < ReferencesConfig.references.length
    ) {
      this.setState({
        index: index
      });
    }
  };

  checkStepValidity = index => {
    return (
      this.state.index !== index &&
      index >= 0 &&
      index < ReferencesConfig.references.length
    );
  };

  renderDots = count => {
    const dots = [];
    for (let i = 0; i < count; i++) {
      let isActive = this.state.index === i ? "activeDot" : "";
      dots.push(
        <button
          key={i}
          className={"dot dot" + i + " " + isActive}
          onClick={() => this.handleClick(i)}
        />
      );
    }
    dots.push(
      <p
        key="arrowLeft"
        className={
          "arrow" +
          (!this.checkStepValidity(this.state.index - 1) ? " disabled" : "")
        }
        onClick={() => this.handleClick(this.state.index - 1)}
      >
        <FontAwesome name="angle-left" />
      </p>
    );
    dots.push(
      <p
        key="arrowRight"
        className={
          "arrow right" +
          (!this.checkStepValidity(this.state.index + 1) ? " disabled" : "")
        }
        onClick={() => this.handleClick(this.state.index + 1)}
      >
        <FontAwesome name="angle-right" />
      </p>
    );
    return <div className="nav">{dots}</div>;
  };

  render() {
    const { index } = this.state;
    let references = ReferencesConfig.references.map((prize, i) => {
      return (
        <div className="swipeSlide" key={i} id={"slide" + i}>
          <p
            className="grayscale img"
            style={{
              backgroundImage:
                "url(" +
                process.env.REACT_APP_MEDIA_CONTENT +
                "logos/" +
                prize.logo +
                ")"
            }}
            alt={prize.title}
          />
          <h4 className="refTitle">
            <FormattedMessage
              id={"References.title." + prize.clientName}
              defaultMessage="reference title"
            />
          </h4>
          <p className="refText">
            “
            <FormattedMessage
              id={"References.text." + prize.clientName}
              defaultMessage="reference text"
            />
            ”
          </p>
          <p className="refAuthor">{prize.personName}</p>
        </div>
      );
    });
    return (
      <div className="references">
        <h2 className="headerTitle">
          <FormattedMessage id="References.title" defaultMessage="References" />
        </h2>
        <div className="carrousel">
          <SwipeableViews
            index={index}
            onChangeIndex={this.handleChangeIndex}
            interval={4000}
            enableMouseEvents
            style={{ textAlign: "center" }}
          >
            {references}
          </SwipeableViews>
          {this.renderDots(references.length)}
        </div>
      </div>
    );
  }
}

export default References;



// WEBPACK FOOTER //
// ./src/containers/references/References.js